import {API_ROOT_URL} from 'envs/_current/config'
import createPath from 'helpers/createPath'
import {createAsyncAction} from 'modules/asyncCache'
import {schema} from 'normalizr'
import {baseFieldTypes} from './base/baseFieldTypes'
import {examinationSchema} from './exam'
import {
    articleSchema,
    askSchema,
    channelSchema,
    codiDocumentSchema,
    documentSchema,
    organizationSchema,
    postSchema,
    userSchema,
} from './schema'
import {eventSchema} from './schema/event'
import {keywordSchema} from './schema/keyword'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'
import {courseSchema} from "./course";
import {musicSchema} from "./music";

const fields = ['keyword']
const fieldTypes = {
    keyword: baseFieldTypes.string,
}
const transform = createTransform()
// Route::get('search/keyword', 'SearchController@getRecommendKeywords');
export const search_getRecommendKeywords_Api = {
    backend: ``,
    root: API_ROOT_URL,
    path: '/search/keyword/:params',
    method: 'GET',
    fields: ['keyword'],
    fieldTypes: {
        keyword: baseFieldTypes.string,
    },
    transform,
}
export const create_search_getRecommendKeywords_Api_action =
    () =>
        ({prefixStr = '', query, values, maxAge = -1}) =>
            createAsyncAction({
                prefixStr: prefixStr + '@search_getRecommendKeywords_Api',
                query,
                values,
                apiInfo: search_getRecommendKeywords_Api,
                maxAge,
            })

// Route::get('search/object/{type}', 'SearchController@getDataWithType');
export const search_getDataWithType_ApiS_schema = new schema.Entity(
    'searchItems',
    {
        owner: new schema.Union(
            {
                article: articleSchema,
                user: userSchema,
                channel: channelSchema,
                post: postSchema,
                ask: askSchema,
                music: musicSchema,
                event: eventSchema,
                organization: organizationSchema,
                codi_document: codiDocumentSchema,
            },
            '_type'
        ),
    },
    {
        idAttribute: (value) => value.username || value.idname || value.id,
        // idAttribute: (value) => `${value.owner_type}_${value.owner_id}`,
    }
)
export const search_getDataWithType_Api = {
    backend: ``,
    root: API_ROOT_URL,
    path: '/search/object/:type',
    method: 'GET',
    fields,
    paramsFields: ['keyword', 'categories'],
    fieldTypes,
    schema: search_getDataWithType_ApiS_schema,
    transform: createListTransform(search_getDataWithType_ApiS_schema),
}
export const create_search_getDataWithType_Api_action =
    () =>
        ({prefixStr = 'search_getDataWithType_Api', query, values, maxAge = -1}) =>
            createAsyncAction({
                prefixStr: prefixStr + '@search_getDataWithType_Api',
                query,
                values,
                apiInfo: search_getDataWithType_Api,
                maxAge,
            })

// search/filter-data/{type?}
export const search_loadFilterData_Api = {
    name: 'search_loadFilterData',
    backend: ``,
    root: API_ROOT_URL,
    path: '/search/filter-data/:type',
    method: 'GET',
    paramsFields: ['category', 'keyword'],
    schema: search_getDataWithType_ApiS_schema,
    transform: createListTransform(search_getDataWithType_ApiS_schema),
}

// search/filter-data/document
export const search_loadFilterDocumentData_Api = {
    name: 'search_loadFilterDocumentData',
    backend: ``,
    root: API_ROOT_URL,
    path: '/search/filter-data/document',
    method: 'GET',
    paramsFields: ['category', 'keyword'],
    schema: documentSchema,
    transform: createListTransform(documentSchema),
}

// search/filter-data/codi-document Route::get('search/filter-data/codi-document', 'SearchController@searchSubstantiveDocumentData');
export const search_loadFilterSubstantiveDocumentData_Api = {
    name: 'search_loadFilterSubstantiveDocumentData',
    backend: ``,
    root: API_ROOT_URL,
    path: '/search/filter-data/codi-document',
    method: 'GET',
    paramsFields: ['category', 'keyword'],
    schema: codiDocumentSchema,
    transform: createListTransform(codiDocumentSchema),
}


// search/filter-data/music Route::get('search/filter-data/music', 'SearchController@searchMusicData');
export const search_loadFilterMusicData_Api = {
    name: 'search_loadFilterMusicData_Api',
    backend: ``,
    root: API_ROOT_URL,
    path: '/search/filter-data/music',
    method: 'GET',
    paramsFields: ['category', 'keyword', 'music_type', 'music_author'],
    schema: musicSchema,
    transform: createListTransform(musicSchema),
}

export const search_loadFilterExaminationData_Api = {
    name: 'search_loadFilterExaminationData',
    backend: ``,
    root: API_ROOT_URL,
    path: '/search/filter-data/examination',
    method: 'GET',
    paramsFields: ['category', 'keyword'],
    schema: examinationSchema,
    transform: createListTransform(examinationSchema),
}

export const search_loadFilterCourseData_Api = {
    name: 'search_loadFilterExaminationData',
    backend: ``,
    root: API_ROOT_URL,
    path: '/search/filter-data/course',
    method: 'GET',
    paramsFields: ['category', 'keyword'],
    schema: courseSchema,
    transform: createListTransform(courseSchema),
}

// search/filter-data/article
export const search_loadFilterArticleData_Api = {
    name: 'search_loadFilterArticleData',
    backend: ``,
    root: API_ROOT_URL,
    path: '/search/filter-data/article',
    method: 'GET',
    paramsFields: ['category', 'keyword'],
    schema: articleSchema,
    transform: createListTransform(articleSchema),
}

// search/filter-data/keyword
export const search_loadFilterKeywordData_Api = {
    name: 'search_loadFilterKeywordData_Api',
    backend: ``,
    root: API_ROOT_URL,
    path: '/search/filter-data/keyword',
    method: 'GET',
    paramsFields: ['category', 'keyword'],
    schema: keywordSchema,
    transform: createListTransform(keywordSchema),
}

// Route::get('search/filter-params/{type?}', 'SearchController@getFilterParams');
export const search_filterParams_Api = {
    name: 'search_filterParams',
    backend: ``,
    root: API_ROOT_URL,
    path: '/search/filter-params/:type',
    method: 'GET',
}

export const search_getTags_Api = {
    backend: ``,
    root: API_ROOT_URL,
    path: '/tags/keyword/:keyword/search',
    method: 'GET',
}

// Route::get('search/keyword', 'SearchController@getSuggestedKeywords'); // param: keyword
export const create_getSuggestedKeywords_Api = ({query, ...props} = {}) => ({
    backend: ``,
    method: 'GET',
    root: API_ROOT_URL,
    paramsFields: ['keyword'],
    path: createPath({
        path: '/search/keyword',
    }),
    ...props,
})

// Route::get('search/keyword', 'SearchController@getSuggestedKeywords');
export const search_getSuggestedKeywords_Api = {
    backend: ``,
    method: 'GET',
    root: API_ROOT_URL,
    paramsFields: ['keyword', 'type', 'language'],
    path: '/search/keyword',
}

export const search_fetchObjects_Api = () => ({
    backend: `Route::get('search/objects', 'SearchController@fetchObjects');`,
    method: 'GET',
    root: API_ROOT_URL,
    paramsFields: ['keyword', 'owner_type', 'owner_id'],
    path: createPath({
        path: '/search/objects',
    }),
})

const _searchSchema = new schema.Union(
    {
        user: userSchema,
    },
    '_type'
)

export const search_searchObjects_Api = {
    backend: `Route::get('search/objects', 'SearchController@fetchObjects');`,
    root: API_ROOT_URL,
    method: 'GET',
    path: '/search/objects',
    paramsFields: ['keyword', 'type'],
    fields,
    fieldTypes,
    schema: _searchSchema,
    transform: createListTransform(_searchSchema),
}

export const search_fetchAvailableOwners_Api = {
    backend: `Route::get('search/available-owners/{type}/{id}', 'SearchController@fetchAvailableOwners'); // param: keyword`,
    path: '/search/available-owners/:type/:id',
    method: 'GET',
    root: API_ROOT_URL,
    paramsFields: ['keyword'],
}


export const promoSchema = new schema.Union(
    {
        user: userSchema,
        channel: channelSchema,
        examination: examinationSchema,
        event: eventSchema,
        course: courseSchema,
    },
    '_type'
)

export const promo_add_Api = {
    backend: `Route::post('recommendations/promos/add', 'PromoteController@add');`,
    root: API_ROOT_URL,
    path: '/recommendations/promos/add',
    method: 'POST',
    fields,
    fieldTypes,
    schema: promoSchema.define,
    transform: createTransform(promoSchema, 'data'),
}

export const promo_remove_Api = {
    backend: `Route::post('recommendations/promos/remove', 'PromoteController@remove');`,
    root: API_ROOT_URL,
    path: '/recommendations/promos/remove',
    method: 'POST',
    fields,
    fieldTypes,
    schema: promoSchema.define,
    transform: createTransform(promoSchema, 'data'),
}

// Route::get('lookup/constants/{type}/gets', 'LookupController@getConstants');
export const lookup_getConstants_Api = {
    backend: `Route::get('lookup/constants/{type}/gets', 'LookupController@getConstants');`,
    path: '/lookup/constants/:type/gets',
    method: 'GET',
    root: API_ROOT_URL,
    paramsFields: ['keyword'],
}